const selectors = {
  skeletonID: "drawer-skeleton",
  drawerContent: ".custom-drawer__content",
  drawerWrapper: ".custom-drawer__wrapper",
  drawerClose: ".custom-drawer__close"
}


class CustomDrawer {
  constructor() {
    this.drawerElement = null
    this.drawerSkeletonHTML = null
    this.drawerIsOpen = false
    this.templateId = null
    this.animationDelay = 300

    this.attachEventListeners()
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleEscapePress = this.handleEscapePress.bind(this)
    this.handleCloseButtonClick = this.handleCloseButtonClick.bind(this)
  }

  init(event) {
    this.templateId = event.detail.templateId
    this.callbackEl = event.detail.callbackEvent || null

    if (!this.templateId && this.drawerIsOpen) return



    this.loadSkeleton()
    this.loadTemplate()

    if (!this.templateHTML || !this.drawerSkeletonHTML) return

    this.renderDrawer()
    this.defineDrawerElements()
    this.openDrawer()

    if (this.callbackEl) {
      this.elTarget = event.target
    }
  }


  toggleCallbackElements() {
    if (!this.elTarget) {
      return null
    }
    // this.elTarget.toggleAttribute('open', this.drawerIsOpen);
    this.elTarget.classList.toggle('drawer-opened', this.drawerIsOpen);

  }

  defineDrawerElements() {
    this.drawerWrapper = this.drawerElement.querySelector(selectors.drawerWrapper)
    this.drawerClose = this.drawerElement.querySelector(selectors.drawerClose)
  }

  loadSkeleton() {
    this.drawerSkeletonHTML = document.getElementById(
      selectors.skeletonID)?.content.cloneNode(true)
  }

  loadTemplate() {
    const template = document.getElementById(this.templateId)
    if (template) {
      this.templateHTML = template.content.cloneNode(true)
    }
  }

  attachEventListeners() {
    window.addEventListener("customDrawerOpen",
      this.debounce_leading(this.init.bind(this), this.animationDelay))
  }

  renderDrawer() {
    if (this.drawerElement) return
    this.drawerElement = document.createElement("div")
    this.drawerElement.setAttribute("id", 'drawer-'+this.templateId);
    this.drawerElement.classList.add("custom-drawer")
    this.drawerElement.appendChild(this.drawerSkeletonHTML)
    this.drawerElement.querySelector(selectors.drawerContent)?.appendChild(this.templateHTML)
    document.body.appendChild(this.drawerElement)
  }

  openDrawer() {
    if (!this.drawerIsOpen) {
      setTimeout(() => {
        this.drawerIsOpen = true
        this.drawerElement.classList.add("open")
        this.addDrawerEvents()
        this.toggleCallbackElements();
      }, 10)
      this.lockScroll()
    }
  }

  addDrawerEvents() {
    document.addEventListener("click",
      this.handleOutsideClick)
    document.addEventListener("keydown",
      this.handleEscapePress)
    this.drawerClose?.addEventListener("click",
      this.handleCloseButtonClick);
  }

  removeDrawerEvents() {
    document.removeEventListener("click",
      this.handleOutsideClick)
    document.removeEventListener("keydown",
      this.handleEscapePress)
  }

  closeDrawer() {
    this.unlockScroll()

    if (this.drawerIsOpen) {

      this.drawerElement.classList.remove("open")
      this.removeDrawerEvents();

      setTimeout(() => {
        this.drawerIsOpen = false
        this.toggleCallbackElements();
        this.removeDrawer()
      }, this.animationDelay)
    }
  }

  removeDrawer() {
    if (this.drawerElement) {
      document.body.removeChild(this.drawerElement)
      this.drawerElement = null
    }
  }

  handleOutsideClick(event) {
    if (this.drawerIsOpen && this.drawerElement && !this.drawerWrapper.contains(event.target)) {
      this.closeDrawer()
    }
  }

  handleEscapePress(event) {
    if (this.drawerIsOpen && event.key === "Escape") {
      this.closeDrawer()
    }
  }

  handleCloseButtonClick() {
    this.closeDrawer();
  }

  lockScroll() {
    document.querySelector("body").classList.add("modal__open")
    document.querySelector("html").classList.add("modal__open")
  }

  unlockScroll() {
    document.querySelector("body").classList.remove("modal__open")
    document.querySelector("html").classList.remove("modal__open")
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }

  debounce_leading(func, timeout = 300) {
    let timer
    return (...args) => {
      if (!timer) {
        func.apply(this, args)
      }
      clearTimeout(timer)
      timer = setTimeout(() => {
        timer = undefined
      }, timeout)
    }
  }
}

export default CustomDrawer

